export default __webpack_public_path__ + "static/media/Flag_of_Suriname.07a31e52.svg";